import { useState } from "react";
import {
  Box,
  Button,
  CardHeader,
  DataGrid,
  Dialog,
  DialogActions,
  DialogContent,
  IconButton,
  Tooltip,
  Typography,
} from "../../../../../components";
import { formatPrice } from "../../../../../utils";
import AdicionarConvenioDialog from "./adicionar-convenio-dialog.component";
import { notification } from "../../../../../services";

const EmissaoBoletoDialog = ({
  open,
  setOpen,
  boletos,
  setBoletos,
  emitirBoletos,
  dadosNfSaida,
}) => {
  const [openConvenioDialog, setOpenConvenioDialog] = useState(false);
  const [convenios, setConvenios] = useState([]);
  const [boletoSelecionado, setBoletoSelecionado] = useState(null);

  const colunas = [
    {
      field: "meioPagamentoSelecionado",
      headerName: "Boleto",
      flex: 100,
      sortable: false,
      valueGetter: (params) => params.value.descricao,
    },
    {
      field: "convenioSelecionado",
      headerName: "Convênio",
      flex: 100,
      sortable: false,
      renderCell: (params) =>
        params.value
          ? renderConvenioSelecionado(params)
          : renderSelecaoConvenio(params),
    },
    {
      field: "valorTitulo",
      headerName: "Valor do Título",
      flex: 50,
      sortable: false,
      align: "right",
      headerAlign: "right",
      valueGetter: (params) => formatPrice(params.value),
    },
  ];

  const renderConvenioSelecionado = (params) => {
    return (
      <Box
        className="d-flex align-items-center justify-content-between"
        sx={{
          width: "100%",
          height: "100%",
        }}
      >
        <Typography
          sx={{
            fontFamily: "Montserrat, sans-serif",
            fontSize: "14px",
          }}
        >
          {`${params.value.numero} - ${params.value.descricao}`}
        </Typography>
        <IconButton
          sx={{
            width: 35,
            height: 35,
            borderRadius: "50%",
            minWidth: "15px",
            boxShadow: "none",
          }}
          onClick={(e) => handleChangeConvenio(e, params)}
        >
          <Tooltip title="Editar Convênio" arrow placement="right">
            <i className="ph-fill ph-pencil" style={{ fontSize: 18 }}></i>
          </Tooltip>
        </IconButton>
      </Box>
    );
  };

  const renderSelecaoConvenio = (params) => {
    return (
      <Box
        className="d-flex justify-content-center align-items-center"
        sx={{
          width: "100%",
          height: "100%",
        }}
      >
        <Tooltip title="Adicionar convênio" arrow placement="bottom">
          <Button
            variant="contained"
            size="small"
            sx={{
              width: 35,
              height: 35,
              borderRadius: "50%",
              minWidth: "15px",
              boxShadow: "none",
            }}
            onClick={(e) => handleChangeConvenio(e, params)}
          >
            <i
              className="ph-bold ph-plus"
              style={{ color: "#fff", fontSize: 15 }}
            ></i>
          </Button>
        </Tooltip>
      </Box>
    );
  };

  function handleChangeConvenio(event, params) {
    event.stopPropagation();
    setConvenios(params.row.conta.convenios);
    setBoletoSelecionado(params.row);
    setOpenConvenioDialog(true);
  }

  function handleClose() {
    setOpen(false);
  }

  async function handleSubmit() {
    const boletoSemConvenio = boletos.find((item) => !item.convenioSelecionado);
    if (boletoSemConvenio) {
      notification.alertaGenericos(
        "É obrigatório um convênio para cada boleto",
      );
      return;
    }
    await emitirBoletos(boletos, dadosNfSaida);
  }

  return (
    <>
      <Dialog
        fullWidth
        maxWidth={"lg"}
        open={open}
        onClose={() => handleClose()}
      >
        <CardHeader title="Emissão de Boletos" className="m-2" />
        <DialogContent>
          <DataGrid
            rows={boletos}
            columns={colunas}
            rowCount={boletos.length}
            disableAcoes
          />
        </DialogContent>
        <DialogActions className="m-3">
          <Button color="success" variant="contained" onClick={handleSubmit}>
            Confirmar
          </Button>
        </DialogActions>
      </Dialog>
      <AdicionarConvenioDialog
        open={openConvenioDialog}
        setOpen={setOpenConvenioDialog}
        convenios={convenios}
        boletos={boletos}
        setBoletos={setBoletos}
        boletoSelecionado={boletoSelecionado}
      />
    </>
  );
};

export default EmissaoBoletoDialog;
